import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'


const _hoisted_1 = { class: "user-profile-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "user-profile-title-text h5" }
const _hoisted_4 = { class: "integration-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "user-profile-back-button small-text-grey",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
      }, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("component-profile-view.user-profile")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ta_button, {
        class: "integration-button",
        text: _ctx.asanaText,
        enableLoading: _ctx.enabledLoader,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerAsanaIntegration()))
      }, null, 8, ["text", "enableLoading"])
    ])
  ]))
}